import axios from 'axios';
import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import ColoredCircle from '../components/ColoredCircle';
import { useDispatch } from 'react-redux';
import { BASE_URL, EMAIL_VERIFY } from '../utills/ApplicationRouting';
import { clearAuthToken, setToken } from '../redux/Qps';
import CommonContainer from "../components/CommonContainer";
import { Typography } from "@mui/material";

function EmailVerify() {
  const { token, tokenId } = useParams();
  const [status, setStatus] = useState('');
  const dispatch = useDispatch('')
  let navigate = useNavigate();
  const [message, setMessage] = useState('')

  const getEmailVerification = async () => {
    try {
      if (token) {
        localStorage.removeItem("token");
        localStorage.removeItem("persist:root");

        dispatch(clearAuthToken());
        dispatch(setToken(null));
        return
      }
      const response = await axios.get(`${BASE_URL}${EMAIL_VERIFY}${tokenId}`, {});
      console.log(response.data);

      if (response.status === 200) {
        const statuss = response.status;
        setStatus(statuss);
        setMessage(response.data)
        dispatch(clearAuthToken());

        setTimeout(() => {
          navigate('/login')
        }, 5000)
      } else {
        throw new Error('Failed to fetch data');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setMessage(error.response.data.message)
    }
  };

  useEffect(() => {
    getEmailVerification();
  }, [tokenId]);
  return (
   <div className="w-full bg-gray-100">
  <CommonContainer>
    <div className="min-h-[80vh] flex items-center justify-center py-12">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8 text-center">
      <ColoredCircle isSuccess={status === 200} />

<Typography
  variant="h6"
  className="font-bold mt-6"
>
  {status === 200 ? "Email Verified" : "Verification Failed"}
</Typography>

<p className="text-gray-600 text-base mt-3">
  {message}
</p>

{status === 200 && (
  <div
    className="text-gray-500 mt-6"
    style={{ fontSize: "10px" }}
  >
    You will be redirected to the Login page in a few seconds.
  </div>
)}
</div>
  </div>
</CommonContainer>
 </div>
  )
}

export default EmailVerify
